import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import "react-chat-elements/dist/main.css" // removed: legacy CSS conflicts with new UI
import MainRouter from './containers/MainRouter';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <MainRouter />
    </AuthProvider>
  </React.StrictMode>
);